export const tabs = {
  all: 'all',
  consideration: 'consideration',
  template: 'template',
  archived: 'archived',
  myTemplates: 'myTemplates',
  studentsWorks: 'studentsWorks',
  corrections: 'corrections',
  deletedTemplates: 'deletedTemplates',
};
